import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { HERO_IMAGE } from "./data/images";
import { initMetaPixel } from "./utils/metaPixel";
import { warmUpImages } from "./utils/preloadImages";
initMetaPixel();
function addLink(rel: string, href: string, extra?: Partial<HTMLLinkElement>) {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  Object.assign(link, extra ?? {});
  document.head.appendChild(link);
}

// Warm up the font + CDN connections and start the hero image before React mounts.
addLink("preconnect", "https://fonts.googleapis.com");
addLink("preconnect", "https://fonts.gstatic.com", {
  crossOrigin: "anonymous"
});
addLink("preconnect", "https://cdn.magicpatterns.com");
addLink("preload", HERO_IMAGE, {
  as: "image",
  fetchPriority: "high"
} as Partial<HTMLLinkElement>);

// Open the connection to the Shopify store now, so the checkout click does not
// pay for DNS + TLS at the moment the buyer is waiting.
addLink("preconnect", "https://myeasyguide.online", {
  crossOrigin: "anonymous"
});
addLink("dns-prefetch", "https://myeasyguide.online");
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-235" data-mp="10oam51u057cv" />);
}

// Everything below the hero is fetched only once the page is interactive.
warmUpImages();